import { ADD_BUSY, BusyActionTypes, REMOVE_BUSY } from './types'

export const addBusy = (blocking = false): BusyActionTypes => ({
		type: ADD_BUSY,
		payload: {
			blocking
		}
	})

export const removeBusy = (blocking = false): BusyActionTypes => ({
		type: REMOVE_BUSY,
		payload: {
			blocking
		}
	})
